import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated, isTokenExpired } from '@/lib/auth';

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();

  if (!isAuthenticated() || isTokenExpired()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
